import { Holiday } from '../holidays';

export const UK_HOLIDAYS: Record<number, Holiday[]> = {
    2024: [
        { name: "New Year's", date: new Date(2024, 0, 1) },
        { name: "Good Friday", date: new Date(2024, 2, 29) },
        { name: "Easter Monday", date: new Date(2024, 3, 1) },
        { name: "Early May Bank", date: new Date(2024, 4, 6) },
        { name: "Spring Bank", date: new Date(2024, 4, 27) },
        { name: "Summer Bank", date: new Date(2024, 7, 26) },
        { name: "Christmas", date: new Date(2024, 11, 25) },
        { name: "Boxing Day", date: new Date(2024, 11, 26) }
    ],
    2025: [
        { name: "New Year's", date: new Date(2025, 0, 1) },
        { name: "Good Friday", date: new Date(2025, 3, 18) },
        { name: "Easter Monday", date: new Date(2025, 3, 21) },
        { name: "Early May Bank", date: new Date(2025, 4, 5) },
        { name: "Spring Bank", date: new Date(2025, 4, 26) },
        { name: "Summer Bank", date: new Date(2025, 7, 25) },
        { name: "Christmas", date: new Date(2025, 11, 25) },
        { name: "Boxing Day", date: new Date(2025, 11, 26) }
    ],
    2026: [
        { name: "New Year's", date: new Date(2026, 0, 1) },
        { name: "Good Friday", date: new Date(2026, 3, 3) },
        { name: "Easter Monday", date: new Date(2026, 3, 6) },
        { name: "Early May Bank", date: new Date(2026, 4, 4) },
        { name: "Spring Bank", date: new Date(2026, 4, 25) },
        { name: "Summer Bank", date: new Date(2026, 7, 31) },
        { name: "Christmas", date: new Date(2026, 11, 25) },
        { name: "Boxing Day", date: new Date(2026, 11, 28) }
    ]
};
